import React from "react";
import MangeDashboard from "./MangeDashboard";
import { Link } from "react-router-dom";


export default function (){
    return(
        <MangeDashboard>


        <div className="verification section-padding">
            <div className="container h-100">
                <div className="row justify-content-center h-100 align-items-center">
                    <div className="col-xl-5 col-md-6">
                        <div className="auth-form card">
                            <div className="card-body">
                                <form className="identity-upload">
                                    <div className="identity-content">
                                        <span className="icon"><i className="fa fa-check"/></span>
                                        <h6> هویت تأیید شده </h6>
                                        <p className={'text-large'}>تبریک می گویم هویت شما با موفقیت تأیید شده و محدودیت سرمایه گذاری شما افزایش
                                            یافته است.</p>
                                    </div>

                                    <div className="text-center mb-4">
                                        <Link to={'/'} className="btn btn-success pl-5 pr-5 text-white">صفحه  اصلی</Link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        </MangeDashboard>


    )

}